module.exports = __webpack_public_path__ + "static/media/threatcop-back.e69e76b6.png";